var React = require('react');

function ArrowUpInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5 13.5C7.5 13.7761 7.72385 14 8 14C8.27614 14 8.5 13.7761 8.5 13.5L8.5 3.80298L12.1283 7.83448C12.3131 8.03974 12.6292 8.05638 12.8345 7.87165C13.0397 7.68692 13.0564 7.37077 12.8716 7.16552L8.37164 2.16552C8.27682 2.06016 8.14174 2 8 2C7.85825 2 7.72317 2.06016 7.62835 2.16552L3.12835 7.16552C2.94362 7.37077 2.96026 7.68692 3.16551 7.87165C3.37077 8.05638 3.68691 8.03974 3.87164 7.83448L7.5 3.80298L7.5 13.5Z","fill":"black"}));
}

ArrowUpInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"black"};

module.exports = ArrowUpInline;

ArrowUpInline.default = ArrowUpInline;
